import { Modal, Timeline, Typography, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const themeColor = "rgb(0, 84, 157)";

const AuditTrailSummaryCountModal = ({
  open,
  onClose,
  auditTrails = [],
}: any) => {
  return (
    <Modal
      title={
        <span style={{ color: themeColor, fontWeight: 600 }}>Audit Trail</span>
      }
      open={open}
      footer={null}
      onCancel={onClose}
      width={950}
    >
      <div
        style={{
          maxHeight: "500px",
          overflowY: "auto",
          padding: "4px 8px",
        }}
      >
        <Timeline
          mode="left"
          items={auditTrails?.map((item: any, index: any) => ({
            color: themeColor,
            dot: <ClockCircleOutlined style={{ color: themeColor }} />,
            children: (
              <div
                style={{
                  background: "#f5f9ff",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  borderLeft: `4px solid ${themeColor}`,
                }}
              >
                <div style={{ marginBottom: 6 }}>
                  <Tag color="blue">Audit No.: {index + 1}</Tag>
                </div>

                <Text strong>
                  {item.processDescription || "No Process Description"}
                </Text>

                <div style={{ marginTop: 4 }}>
                  <Text type="secondary">
                    Processed By: {item.processedBy || "N/A"}
                  </Text>
                </div>

                <div>
                  <Text type="secondary">
                    Date: {item.processedOn || "N/A"}
                  </Text>
                </div>

                {item.remarks && (
                  <div style={{ marginTop: 6 }}>
                    <Text>Remarks: {item.remarks}</Text>
                  </div>
                )}
              </div>
            ),
          }))}
        />
      </div>
    </Modal>
  );
};

export default AuditTrailSummaryCountModal;
